import {
  InsightsIconButton,
  MetricsRefresh,
  MoreAnalyticsIconButton,
  PostMetricsScroller,
  PostMetricsWrapper,
} from '~publish/components/PostDetails/PostMetrics'
import { useCanShowAnalyzeFallback } from '~publish/hooks/useAnalyzeSunsetEnabled'
import { useGetEngagementUrl } from '~publish/hooks/useGetEngagementUrl'
import { isChannelSupportedByInsights } from '~publish/pages/Insights/utils'

import { getAnalyzeUrl } from '../helpers'
import { usePostData } from '../PostCardContext'

import styles from './PostCardMetrics.module.css'

import type { JSX } from 'react'

export const PostCardMetrics = (): JSX.Element | null => {
  const { metrics, channel, id: postId } = usePostData()

  const canShowAnalyzeFallback = useCanShowAnalyzeFallback()

  const engageUrl = useGetEngagementUrl(channel, postId)
  const analyzeUrl = getAnalyzeUrl(channel)

  const shouldShowAnalyticsCTA =
    canShowAnalyzeFallback &&
    (channel.service === 'linkedin' ? channel.type === 'page' : true)
  const shouldShowInsightsCTA = isChannelSupportedByInsights(
    channel.service,
    channel.type,
  )

  return (
    <PostMetricsWrapper className={styles.metricsWrapper}>
      <PostMetricsScroller metrics={metrics ?? []} engageUrl={engageUrl} />
      {shouldShowInsightsCTA ? (
        <InsightsIconButton insightsUrl={`/insights/${channel.id}`} />
      ) : (
        shouldShowAnalyticsCTA &&
        analyzeUrl && <MoreAnalyticsIconButton analyzeUrl={analyzeUrl} />
      )}
      <MetricsRefresh />
    </PostMetricsWrapper>
  )
}

PostCardMetrics.displayName = 'PostCardMetrics'
